import { Component, OnInit } from '@angular/core';
import { Employee } from '../models/wizard.model';
import { UserService } from '../services/user.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  employeeProfile: any;
  constructor(
    public readonly userService: UserService,
    private readonly location: Location
  ) {}

  ngOnInit(): void {
    this.userService.GetEmployeeProfile().subscribe(
      (responsesData: { body: any }) => {
        this.employeeProfile = responsesData.body as Employee;
      },
      (error: any) => {}
    );
  }

  GoBack(): any {
    this.location.back();
  }
}
